        var isLoaded;
        var shimerClass = '.responsive-shimmer-block';
        document.addEventListener("DOMContentLoaded", function () {
            if (isLoaded != true) {
                isLoaded = true;
                window.addEventListener('popstate', function (event) {
                    reloadPageByUrl(event.state.Url);
                });
                $('#search-text').on("keypress", function (e) {
                    if (e.keyCode == 13) {
                        submitDataToSearchAction();

                        return false; // prevent the button click from happening
                    }
                });

                $(document).on('change', '#category-id', function () {
                    submitDataToSearchAction();
                })

                $(document).on('change', '#location-id', function () {
                    submitDataToSearchAction();
                })

                $(document).on('click', '#is-online', function () {
                    submitDataToSearchAction();
                })

            }
            $('#storeSearch').click(function (e) {
                submitDataToSearchAction();
            });

            function reloadPageByUrl(url) {
                //alert(shimerClass + ' started');
                $(shimerClass).removeClass('hidden');
                $('.MainBlock').addClass('hidden');
                window.scrollTo(0, 0);

                $.ajax({
                    url: url,
                    context: document.body,
                    success: function (resp, x) {
                        //alert('success');
                        $(shimerClass).addClass('hidden');
                        $('.MainBlock').removeClass('hidden');
                        //$(this).empty();
                        $(this).html(resp);
                    }
                });
            }

            function submitDataToSearchAction() {
                 var requestData = {
                    search: $('#search-text').val(),
                    locationId: $('#location-id').val(),
                    categoryId: $('#category-id').val(),
                    isOnline: $('#is-online').is(":checked")
                }
                //alert('submit');
                $(shimerClass).removeClass('hidden');
                $('.MainBlock').addClass('hidden');
                $.ajax({
                    url: pzStoreListing.v0,
                    type: "post",
                    data: JSON.stringify(requestData),
                    contentType: "application/json",
                    processData: false,
                })
                .done(function (data) {
                    //alert('success');
                    $(shimerClass).addClass('hidden');
                    $('.MainBlock').removeClass('hidden');
                    ChangeUrl(data.Result.Title, data.Result.Url);
                    ChangeMeta(data.Result);
                    $('#tHeader').text(data.Result.PageHeader);
                    $(('#' + pzStoreListing.v1)).html(data.Html);

                    // the swapped-in pager ships hidden and is only revealed by
                    // setupPagination, which is bound to DOMContentLoaded and never fires again.
                    setTimeout(() => {
                        requestAnimationFrame(() => {
                            requestAnimationFrame(() => {
                                if (typeof setupPagination === 'function') {
                                    setupPagination();
                                }
                            });
                        });
                    }, 0);

                    $('.ShimmerImgBlock').removeClass('hidden');
                    $('.ShimmeredImgBlock').addClass('visually-hidden-shimmer');
                    try {
                        if (data.hrefLang != null && data.hrefLang != undefined) {
                            var langs = data.hrefLang;
                            for (var i = 0; i < langs.length; i++) {
                                $('.' + langs[i].key).attr('href', langs[i].value);
                            }
                        }
                    } catch (e) { }
                }).fail(function (data) {
                    $(shimerClass).addClass('hidden');
                    $('.MainBlock').removeClass('hidden');
                    //alert(data.statusText);
                });
            }

            function ChangeUrl(title, url) {
                if (typeof (history.replaceState) != "undefined") {
                    var obj = { Title: title, Url: url };
                    history.replaceState(obj, obj.Title, obj.Url);
                } else {
                    alert("Browser does not support HTML5.");
                }
            }

            function ChangeMeta(result) {
                $(document).prop('title', result.MetaTitle);
                $('meta[name=title]').attr('content', result.MetaTitle);
                $('meta[name=description]').attr('content', result.MetaTitle);
            }
        });
    
